"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VisuallyHidden_1 = __importDefault(require("./VisuallyHidden"));

exports.default = VisuallyHidden_1.default;